// Работа с датами: парсинг значений сервера и форматирование для вывода.
export default class DateLib {
    // Приводит строку/число/Date к Date; null — если распарсить нельзя.
    static parse(value) {
        if (value === null || value === undefined || value === '') return null;
        if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
        const date = new Date(value);
        return isNaN(date.getTime()) ? null : date;
    }

    // «19.07.2026 14:30:05» — для таблиц и readonly-полей.
    static formatterDateTime(value) {
        const date = DateLib.parse(value);
        if (date === null) return '';
        return date.toLocaleString('ru-RU', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
        });
    }

    // «19.07.2026» — только дата.
    static formatterDate(value) {
        const date = DateLib.parse(value);
        if (date === null) return '';
        return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }

    // «2026-07-19T14:30» — значение для input type="datetime-local".
    static formatterForInput(value) {
        const date = DateLib.parse(value);
        if (date === null) return '';
        const pad = (number) => String(number).padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
            + `T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    }
}
